import { Directive, HostBinding, HostListener } from '@angular/core';

@Directive({
  selector: 'input[app-base-input], textarea[app-base-input]',
  exportAs: 'appBaseInput'
})
export class InputBaseClass {
  @HostBinding('class') _baseClasses = baseClasses;
  @HostListener('focus', ['$event.target'])
  onClick(input: HTMLInputElement) {
    // @ts-ignore
    if (window?.flutter_inappwebview) {
      const value = input.value;
      const key = !value ? 'Backspace' : value.split('').pop();
      const event = new CustomEvent('keyup', { detail: { key: key } });
      input.dispatchEvent(event);
    }
  }
  @HostListener('keyup', ['$event'])
  onKeyup(e: CustomEvent<{ key: string }>) {
    if (!e.detail) return;
    const input = e.target as HTMLInputElement;
    if (e.detail.key === 'Backspace') return;
    const chars = input.value.split('');
    input.value = chars.slice(0, chars.length - 1).join('');
    input.value += e.detail.key;
  }
  @HostListener('focus', ['$event.target'])
  onFocus(input: HTMLInputElement) {
    const appVersion = localStorage.getItem('app-version');
    if (!appVersion) return;

    const labelHeight = 14;
    const scrollableSelector = '.scrollable-container';
    setTimeout(() => {
      const scrollableContainer = input.closest(scrollableSelector);
      const inputRect = input.getBoundingClientRect();
      let leftPosition = inputRect.left;
      let topPosition = inputRect.top - labelHeight;

      if (scrollableContainer) {
        const containerRect = scrollableContainer.getBoundingClientRect();
        leftPosition = leftPosition - containerRect.left + scrollableContainer.scrollLeft;
        topPosition = topPosition - containerRect.top + scrollableContainer.scrollTop;
      }

      const scrollPosition = {
        left: leftPosition,
        top: topPosition,
        behavior: 'smooth'
      };

      if (scrollableContainer) {
        // @ts-ignore
        scrollableContainer.scrollTo(scrollPosition);
      } else {
        // @ts-ignore
        window.scrollTo(scrollPosition);
      }
    }, 500);
  }
}

const baseClasses =
  'block w-full rounded-xl border border-neutral-200 px-3 py-4 outline-none disabled:pointer-events-none disabled:bg-neutral-200 prose-text-sm';
